<template>
  <div>
    <section class="mb-4 d-flex align-center">
      <h3 v-t="'page.account.bets'" class="text-h5 text-uppercase font-weight-extrabold" />
      <v-spacer />
      <v-btn
        color="grey300"
        tile small class="unwidth"
        :ripple="false" :loading="loading"
        @click="fetchApiData"
      >
        <fai :icon="['fas','sync']" class="grey100--text" />
      </v-btn>
    </section>

    <section>
      <v-data-table
        class="rounded-0 data-table"
        :headers="headers"
        :items="entries"
        :options.sync="options"
        :footer-props="{itemsPerPageOptions: [5, 10, 25]}"
        :server-items-length="total"
        :loading="loading"
      >
        <template #item.game="{ value }">
          <div class="d-flex align-center">
            <game-icon :game="value" class="mr-1 flex-grow-0" width="20" />
            <span v-t="`common.games.${value}`" class="font-weight-semibold" />
          </div>
        </template>
        <template #item.status="{ item, value }">
          <v-progress-circular
            v-if="betStatuses[value] === 'pending'"
            color="blue300"
            indeterminate size="12" width="2" class="mr-1"
          />
          <span v-t="`common.bet_status.${betStatuses[value]}`" class="text-capitalize text-caption blue300--text" />
        </template>
        <template #item.amount="{ value, item }">
          <span v-if="item.game === 'coinflip'">
            ${{ value | toScrap }}
          </span>
          <scrap v-else :class="{'faded-5': betStatuses[item.status] === 'refunded'}" :amount="value" />
        </template>
        <template #item.won="{ value, item }">
          <span v-if="!value" class="text--disabled">&mdash;</span>
          <b v-else class="green500--text">
            <span v-if="item.game === 'coinflip'">$</span>
            <span>{{ value | toScrap }}</span>
          </b>
        </template>
        <template #item.createdAt="{ value }">
          <v-tooltip top color="primary500">
            <template #activator="{on}">
              <span v-on="on">{{ value | relativeTime('twitter') }}</span>
            </template>
            <span>{{ value | toDateFormat('YYYY-MM-DD HH:mm:ss') }}</span>
          </v-tooltip>
        </template>
        <template #item.actions="{ value }">
          <fai
            :icon="['fad', 'info-square']"
            class="text-body-1 mt-1 blue500--text link"
            @click="$toast.info('Coming soon :)')"
          />
        </template>
      </v-data-table>
    </section>
  </div>
</template>

<script>
import { BET_STATUS } from '@/utils/constants'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      total: 0,
      options: {
        sortBy: ['createdAt'],
        sortDesc: [true],
        itemsPerPage: 10,
        mustSort: true,
      },
      headers: [
        { text: this.$t('common.game'), value: 'game', align: 'start' },
        { text: this.$t('common.status'), value: 'status', sortable: false },
        { text: this.$t('common.amount'), value: 'amount', align: 'end' },
        { text: this.$t('common.won'), value: 'won', align: 'end' },
        { text: this.$t('common.time'), value: 'createdAt', align: 'end' },
        { text: '', value: 'actions', width: 8 },
      ],
      entries: [],
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
    }),
    betStatuses() {
      return Object.entries(BET_STATUS).reduce((acc, [k, v]) => {
        acc[v] = k
        return acc
      }, {})
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchApiData()
      },
      deep: true,
    },
  },
  methods: {
    async fetchApiData() {
      // if (this.loading) return

      this.loading = true

      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options

      try {
        // TODO move to store
        const { entries, total } = await this.$socket.request('user.getBetHistory', {
          page,
          sortBy: sortBy[0],
          asc: !sortDesc[0],
          limit: itemsPerPage,
        })

        this.entries = entries.map(i => ({ ...i, createdAt: new Date(i.createdAt).getTime() }))
        this.total = total
      } catch (error) {
        this.entries = []
        this.$toast.error(error.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.data-table ::v-deep {
  background-color: grey(600);

  .v-data-table-header {
    background-color: grey(500);
  }

  .v-data-footer {
    background-color: grey(500);
  }
}

.pagination ::v-deep {
  .v-pagination__item,
  .v-pagination__navigation {
    border-radius: 0;
    background-color: grey(500);
    box-shadow: none;
  }
}
</style>
